import { render, staticRenderFns } from "./LatestPrivacyNews.vue?vue&type=template&id=8c43f0c8&scoped=true"
import script from "./LatestPrivacyNews.vue?vue&type=script&lang=js"
export * from "./LatestPrivacyNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c43f0c8",
  null
  
)

export default component.exports